module.exports = __webpack_public_path__ + "img/tableHead@1x.d4e3e14c.png";